import { ReportsLibrary } from './components/ReportsLibrary';

export default function TumReportsLibrary() {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="space-y-2">
        <h1 className="text-4xl font-bold tracking-tight">Reports Library</h1>
        <p className="text-muted-foreground mt-2 text-lg">
          Browse and download standard reports for your utility data
        </p>
      </div>
      <ReportsLibrary />
    </div>
  );
}

